import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.45625 9.5L0.5 8.54375L4.04375 5L0.5 1.45625L1.45625 0.5L5 4.04375L8.54375 0.5L9.5 1.45625L5.95625 5L9.5 8.54375L8.54375 9.5L5 5.95625L1.45625 9.5Z",
		fill: "#6D6D6E"
	})
});
export default SvgClose;
